// extracted by mini-css-extract-plugin
export default {"csTabNav":"ServiceTabNav_csTabNav__LcL7z","csTabBtn":"ServiceTabNav_csTabBtn__RC2P7","csTabActive":"ServiceTabNav_csTabActive__rQyck"};